import { useQuery } from '@apollo/client';

import { GetApplicationConfiguration } from '@resources/configuration.graphql';

export const useGetConfiguration = application => {
  const { data } = useQuery(GetApplicationConfiguration, {
    variables: { application }
  });
  return data?.configuration[0].configuration || {};
};

export const useIsConfigSettingOn = (app, setting) => {
  const configuration = useGetConfiguration(app);
  return configuration[setting] === 'True';
};

export const useIsConfigurationLoaded = application =>
  Object.keys(useGetConfiguration(application)).length > 0;
